<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <!-- Header -->
    <app-navbar></app-navbar>

    <mat-drawer-container class="h-full flex-auto">
        <!-- Drawer 72 -->
        <mat-drawer
            *ngIf="!isScreenSmall()"
            class="custom-mat-drawer dark:bg-zinc-900"
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            #matDrawer
        >
            <!-- Sidebar -->
            <app-sidebar [sidebarData]="sidebarData()"></app-sidebar>
        </mat-drawer>

        <!-- Drawer 24 -->
        <mat-drawer
            *ngIf="isScreenSmall()"
            class="custom-mat-drawer-dense dark:bg-zinc-900"
            [autoFocus]="false"
            [mode]="iconDrawerMode"
            [opened]="iconDrawerOpened"
            #iconMatDrawer
        >
            <!-- Sidebar -->
            <app-sidebar [sidebarData]="iconSidebarData()"></app-sidebar>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col" (scroll)="onScroll($event)">
            <!-- Main -->
            <div class="flex-auto p-2 dark:bg-zinc-900 sm:p-4">
                <!-- CONTENT GOES HERE -->
                <router-outlet></router-outlet>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
